import Navigationbar from '../components/Navigationbar';
import { useEffect, useState} from 'react';
import { getDocs, collection, getDoc, doc, addDoc, updateDoc, deleteDoc, orderBy, where, query, onSnapshot } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
import { db } from '../firebase-config'
import AdminDropdown from '../components/AdminDropDown';
import DraggableWorkerGrid from '../components/RollefordelingComponents/DraggableWorkerGrid';
import { useSelectedCompany } from '../contexts/SelectedCompanyContext';
import useFetchCompanies from '../hooks/useFetchCompanies';
import '../Styles/Rollefordeling.css'
import '../Styles/button.css'


function Rollefordeling () {
    const auth = getAuth();
    const [workers, setWorkers] = useState([]);

    const [isAdmin, setIsAdmin] = useState(false);
    const [editingWorker, setEditingWorker] = useState(null);

    const [workerName, setWorkerName] = useState('');
    const [role, setRole] = useState('');
    const [companyName, setCompanyName] = useState(''); 
    const [editingWorkerId, setEditingWorkerId] = useState(null);
    
    
    const { selectedCompany, setSelectedCompany } = useSelectedCompany();
    const {companies, isLoading: isCompaniesLoading, error: companyError} = useFetchCompanies();
    const [currentUserData, setCurrentUserData] = useState(null);
    

    useEffect(() => {
      const unsubscribe = getAuth().onAuthStateChanged((user) => {
          if (user) {
              const userUid = user.uid;
              const userRef = doc(db, 'users', userUid);
              getDoc(userRef)
                  .then((docSnapshot) => {
                      if (docSnapshot.exists()) {
                          const userData = docSnapshot.data();
                          setCurrentUserData(userData);
                          setIsAdmin(userData.isAdmin || false);
  
                          
                          const companiesRef = collection(db, 'companies'); 
                          return { userData, companiesRef };
                      }
                      throw new Error("Document doesn't exist");
                  })
                  .catch((error) => {
                      console.error('Error fetching data:', error);
                  });
          } else {
              setIsAdmin(false);
          }
      });

      
      return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!selectedCompany) {
      return;
    }
  
    const workersCollection = collection(db, 'workers');
    const q = query(
      workersCollection,
      where("companyName", "==", selectedCompany),
      orderBy("slot")
    );
  
    
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const updatedWorkers = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setWorkers(updatedWorkers);
      },
      (error) => {
        console.error("Error listening to data: ", error);
      }
    );
  
    return () => unsubscribe();
  }, [selectedCompany]);
  
 
  useEffect(() => {
      
      setCompanyName(selectedCompany); 
  }, [selectedCompany]);
  
  useEffect(() => {
    
    if (selectedCompany) {
        fetchData(selectedCompany);
    }
}, [selectedCompany]);


const fetchData = async (selectedCompanyName) => {
  try {
    if (selectedCompanyName === undefined) {
      console.error("selectedCompanyName is undefined");
      return;
  }
      
      const workersCollection = collection(db, 'workers');
      const q = query(
          workersCollection, 
          where("companyName", "==", selectedCompanyName),
          orderBy("slot")
      );
      
      const workerSnapshot = await getDocs(q);
      const workerList = workerSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      setWorkers(workerList);

    } catch (error) {
      console.error("Error fetching workers: ", error);
    }
  };
  
  const handleMoveWorker = async (newWorkers) => {
    const clonedNewWorkers = JSON.parse(JSON.stringify(newWorkers));

    const movedWorkers = clonedNewWorkers.filter((newWorker) => {
      const oldWorker = workers.find(worker => worker.id === newWorker.id);

    
  
     
      if (!oldWorker) {
          console.error(`No original worker found for id ${newWorker.id}`);
          return false;
      }
  
      return oldWorker.slot !== newWorker.slot;
  });
  
  
   
  
    setWorkers(clonedNewWorkers);
  
    for (let worker of movedWorkers) {
      try {
        const workerRef = doc(db, 'workers', worker.id);
        await updateDoc(workerRef, { slot: worker.slot });
      } catch (error) {
        console.error('Error updating worker slot:', error);
      }
    }
  };
  
  
  
  
  const handleAddWorker = async (newWorker) => {
    try {
      const workersCollection = collection(db, 'workers');
  
      
      let emptySlotIndex = -1;
      for (let i = 0; i < 20; i++) {
        if (!workers.find(worker => worker.slot === i)) {
          emptySlotIndex = i;
          break;
        }
      }
  
      
      if (emptySlotIndex === -1) {
        alert("All slots are filled, cannot add more workers!");
        return;
      } 
      
      
      const docRef = await addDoc(workersCollection, {
        ...newWorker,
        companyName: selectedCompany,
        slot: emptySlotIndex,
      });
  
      
      setWorkers(prevWorkers => [
        ...prevWorkers,
        { ...newWorker, id: docRef.id, slot: emptySlotIndex }
      ]);
  
    } catch (error) {
      console.error("Error adding worker: ", error);
    }
  };
 



const handleUpdateWorker = async (id, updatedData) => {
    try {
        const workerRef = doc(db, 'workers', id);
        await updateDoc(workerRef, updatedData);
        setEditingWorkerId(null);
        fetchData();
    } catch (error) {
        console.error("Error updating worker: ", error);
        alert(error.message);
    }
};
const handleDeleteWorker = async (id) => {
    try {
        const workerRef = doc(db, 'workers', id);
        await deleteDoc(workerRef);

        
        fetchData();
    } catch (error) {
        console.error("Error deleting worker: ", error);
        alert(error.message);
    }
};



return (
    <>
    <Navigationbar />
    <div className='container rollefordeling-container'>
      {auth.currentUser ? (
        <>
          <div>
            <h1 className='main-header'>Roller og Ansvarsområder</h1>
          </div>
          {isAdmin && (
                            <AdminDropdown
                                selectedCompany={selectedCompany}
                                setSelectedCompany={setSelectedCompany}
                                allCompanies={companies}
                            />
                        )}
          <DraggableWorkerGrid workers={workers} onMoveWorker={handleMoveWorker} onDelete={handleDeleteWorker} onEdit={setEditingWorker} onUpdateWorker={handleUpdateWorker} onAddWorker={handleAddWorker} selectedCompany={selectedCompany} isAdmin={isAdmin} onNameChange={(name) => setWorkerName(name)}
              onRolesChange={(roles) => setRole(roles)} />
        </>
      ) : (
        <div className="d-flex justify-content-center mt-4">
        <p style={{fontWeight:'bold'}}>Login for at se roller og Ansvarsområder</p>
    </div>
      )}
    </div>
  </>
);
}
export default Rollefordeling;